
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import httpClient from "@/store/httpClient";
const Chart = require("chart.js");
const Utils = require("chart.js");

@Component
export default class CostDistributionReport extends Vue {
	private chart: any = null;
	private costDistributions: any = [];
	private loading: boolean = false;
	private year: number = new Date().getFullYear();

	private mounted() {
		this.loadReport();
	}

	private get years() {
		var lastYears = [];
		for (let index = new Date().getFullYear(); index >= 2012; index--) {
			lastYears.push(index);
		}
		return lastYears;
	}

	@Watch("year")
	private async loadReport() {
		try {
			this.loading = true;
			const response = await httpClient().get(`Report/GetCostDistribution?year=${this.year}`);
			this.costDistributions = response.data;
			this.updateDiagram();
		} catch (err) {
			console.error("Loading report failed.");
			console.error(err);
			this.$store.commit(
				"setSnackbarErrorText",
				"Fehler beim Laden der Reports. Siehe Konsole."
			);
		} finally {
			this.loading = false;
		}
	}

	private getDatasets() {
		const colors = [
			"#635147",
			"#EFBB20",
			"#704214",
			"#468641",
			"#A3FF00",
			"#00F4C4",
			"#123524",
			"#007EFF",
			"#005A99",
			"#4B0082",
			"#A146FF",
			"#FF0090",
			"#FF2400",
		];

		var data = {
			labels: this.costDistributions.map((c: any) => `${c.name}`),
			datasets: [
				{
					label: "Kostenverteilung",
					data: this.costDistributions.map((c: any) => c.total),
					backgroundColor: colors,
					hoverOffset: 4,
				},
			],
		};
		return data;
	}

	private updateDiagram() {
		const labels = this.costDistributions;

		// Destroy the chart if one already exists.
		if (this.chart != null) {
			this.chart.destroy();
		}

		const ctx = (this.$refs.diagramCanvas as any).getContext("2d");
		this.chart = new Chart(ctx, {
			// The type of chart we want to create
			type: "pie",
			// The data for our dataset
			data: this.getDatasets(),
		});
		this.chart.update();
	}
}
